import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const AVAIL_COLORS = { available: "#4C956C", limited: "#D95D39", unavailable: "#6b7280" };

export default function FacultyRegistry() {
  const [q, setQ] = useState("");
  const [competency, setCompetency] = useState("all");
  const [state, setState] = useState("all");
  const [facets, setFacets] = useState({ competencies: [], states: [] });
  const [rows, setRows] = useState([]);

  useEffect(() => { api.get("/faculty/facets").then(r => setFacets(r.data)); }, []);
  useEffect(() => {
    api.get("/faculty", { params: { q: q || undefined, competency, state }}).then(r => setRows(r.data));
  }, [q, competency, state]);

  return (
    <div data-testid="faculty-registry-module" className="space-y-6">
      <div className="border border-white/10 bg-[#13233F] p-5 grid grid-cols-1 md:grid-cols-12 gap-4">
        <input data-testid="faculty-search" placeholder="Search name, institute, expertise…"
               value={q} onChange={e=>setQ(e.target.value)}
               className="md:col-span-6 bg-navy border border-white/15 text-cream p-3 text-sm focus:outline-none focus:border-sage" />
        <select data-testid="faculty-competency" value={competency} onChange={e=>setCompetency(e.target.value)}
                className="md:col-span-3 bg-navy border border-white/15 text-cream p-3 text-sm font-mono-data">
          <option value="all">All competencies</option>
          {facets.competencies.map(c => <option key={c} value={c}>{c}</option>)}
        </select>
        <select data-testid="faculty-state" value={state} onChange={e=>setState(e.target.value)}
                className="md:col-span-3 bg-navy border border-white/15 text-cream p-3 text-sm font-mono-data">
          <option value="all">All states</option>
          {facets.states.map(s => <option key={s} value={s}>{s}</option>)}
        </select>
      </div>

      <div className="flex items-baseline justify-between">
        <div className="font-mono-data text-xs tracking-[0.25em] uppercase text-[#E8B298]">
          {rows.length} discoverable faculty
        </div>
        <div className="text-xs text-cream/50 font-mono-data">competency-mapped · cross-institutional</div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {rows.map(f => (
          <div key={f.id} data-testid={`faculty-card-${f.id}`}
               className="border border-white/10 bg-[#13233F] p-5 hover:border-sage/40 transition-colors">
            <div className="flex items-start justify-between">
              <div>
                <div className="font-serif-display text-xl">{f.name}</div>
                <div className="text-xs text-cream/60 mt-0.5">{f.institute} · {f.state}</div>
              </div>
              <span className="flex items-center gap-1.5 text-[10px] font-mono-data uppercase tracking-[0.18em]"
                    style={{color: AVAIL_COLORS[f.availability]}}>
                <span className="w-2 h-2 rounded-full" style={{background: AVAIL_COLORS[f.availability]}}/>
                {f.availability}
              </span>
            </div>
            <p className="mt-3 text-sm text-cream/75 leading-relaxed">{f.bio}</p>
            <div className="flex flex-wrap gap-1.5 mt-4">
              {f.competencies.map(c => (
                <span key={c} className="text-[10px] font-mono-data uppercase tracking-[0.18em] px-2 py-0.5 bg-white/5 border border-white/10 text-cream/80">{c}</span>
              ))}
            </div>
            <div className="grid grid-cols-3 gap-3 mt-5 pt-4 border-t border-white/10 text-center">
              <div>
                <div className="font-mono-data text-lg text-[#E8B298]">{f.experience_years}y</div>
                <div className="text-[10px] uppercase tracking-[0.18em] text-cream/50">Experience</div>
              </div>
              <div>
                <div className="font-mono-data text-lg text-[#E8B298]">{f.programs_delivered}</div>
                <div className="text-[10px] uppercase tracking-[0.18em] text-cream/50">Programmes</div>
              </div>
              <div>
                <div className="font-mono-data text-lg text-[#E8B298]">{f.rating}</div>
                <div className="text-[10px] uppercase tracking-[0.18em] text-cream/50">Rating</div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {rows.length === 0 && (
        <div className="border border-white/10 bg-[#13233F] p-10 text-center text-cream/60 font-mono-data text-sm">
          No faculty match the current filters.
        </div>
      )}
    </div>
  );
}
